<template>
  <div class="chargeCategoryManagement">
    <el-form
      :inline="true"
      class="demo-form-inline toolbar"
      style="padding-bottom: 0px"
      @submit.native.prevent
    >
      <el-form-item>
        <el-button type="primary"
                   icon='el-icon-edit-outline'
                   @click="addChargeCategory">{{chargeCategoryManagement.newFeeCategory}}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="warning"
                   icon='el-icon-edit'
                   :disabled="editChargeCategoryDisabled"
                   @click="editChargeCategory">{{chargeCategoryManagement.managementFeeCategory}}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-plus"
          plain
          @click="addCharge"
          >{{ chargeCategoryManagement.addFeeItem }}</el-button
        >
      </el-form-item>
    </el-form>
    <el-row style="margin-top: 1px">
      <el-table
        border
        :data="tableData"
        :element-loading-text="chargeCategoryManagement.loadingText"
        :loading="tableLoading"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
        :span-method="objectSpanMethod"
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          :label="chargeCategoryManagement.category"
          min-width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="itemName"
          :label="chargeCategoryManagement.project"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="chargeStandard"
          :label="chargeCategoryManagement.chargingStandard"
          min-width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="content"
          :label="chargeCategoryManagement.serviceContent"
          min-width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="chargeCategoryManagement.operation"
          min-width="180"
          align="center"
        >
          <template slot-scope="scope">
            
            <el-button
              style="margin-right: 5px"
              type="primary"
              size="mini"
              plain
              v-if="scope.row.expenseTypeId != ''"
              @click="handleEditFeeItem(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              style="margin-right: 5px"
              type="danger"
              size="mini"
              plain
              v-if="scope.row.expenseTypeId != ''"
              @click="handleDeleteFeeItem(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 新建费用类别 和  管理费用类别 的dialog模态框-->
    <el-dialog
      :title="
        feeCategoryOperation
          ? chargeCategoryManagement.newFeeCategory
          : chargeCategoryManagement.managementFeeCategory
      "
      width="30%"
      :visible.sync="dialogVisibleFeeCategoryForm"
      :close-on-click-modal="false"
      @close="closeDialogVisibleFeeCategoryForm"
    >
      <el-form
        :model="feeCategoryForm"
        label-width="100px"
        :rules="feeCategoryFormRules"
        ref="feeCategoryForm"
        label-position="right"
      >
        <el-form-item
          :label="chargeCategoryManagement.serviceCategory"
          prop="name"
        >
          <el-input
            v-if="feeCategoryOperation == true"
            v-model.trim="feeCategoryForm.name"
            auto-complete="off"
            class="width80"
          ></el-input>
          <el-select
            v-else
            v-model="feeCategoryForm.id"
            class="width80"
            @change="handleSelectServiceCategory"
          >
            <el-option
              v-for="item in feeItemOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="费用类别类型"
          prop="code"
        >
          <el-select
            v-model="feeCategoryForm.code"
            class="width80"
          >
            <el-option label="床位费" value="1" />
            <el-option label="护理费" value="2" />
            <el-option label="周期缴费项目" value="0" />
            <el-option label="入院一次性费用" value="3" />
            <el-option label="出院一次性费用" value="4" />
            <el-option label="单次收费项目" value="5" />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="!feeCategoryOperation"
          :label="chargeCategoryManagement.fixChargeCategoryName"
          prop="fixChargeCategoryName"
        >
          <el-input
            v-model.trim="feeCategoryForm.fixChargeCategoryName"
            :disabled="isfeeCategory"
            type="text"
            class="width80"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="chargeCategoryManagement.categoryRemark"
          prop="remark"
        >
          <el-input
            v-model.trim="feeCategoryForm.remark"
            auto-complete="off"
            class="width80"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="chargeCategoryManagement.categoryA"
          prop="canMultipleChoose"
          label-width="200px"
          label-position="left"
        >
          <el-row>
            <el-radio-group
              v-model="feeCategoryForm.canMultipleChoose"
              class="radiomargiTtop"
            >
              <el-radio :label="1">{{ chargeCategoryManagement.yes }}</el-radio>
              <el-radio :label="0">{{ chargeCategoryManagement.no }}</el-radio>
            </el-radio-group>
          </el-row>
        </el-form-item>
        <el-form-item
          :label="chargeCategoryManagement.categoryB"
          prop="needSelectOne"
          label-width="200px"
          label-position="left"
        >
          <el-row>
            <el-radio-group
              v-model="feeCategoryForm.needSelectOne"
              class="radiomargiTtop"
            >
              <el-radio :label="1">{{ chargeCategoryManagement.yes }}</el-radio>
              <el-radio :label="0">{{ chargeCategoryManagement.no }}</el-radio>
            </el-radio-group>
          </el-row>
        </el-form-item>
        <el-form-item
          :label="chargeCategoryManagement.categoryC"
          prop="isSelectFirstone"
          label-width="240px"
          label-position="left"
        >
          <el-row>
            <el-radio-group
              v-model="feeCategoryForm.isSelectFirstone"
              class="radiomargiTtop"
            >
              <el-radio :label="1">{{ chargeCategoryManagement.yes }}</el-radio>
              <el-radio :label="0">{{ chargeCategoryManagement.no }}</el-radio>
            </el-radio-group>
          </el-row>
        </el-form-item>
        <el-form-item label-width="5px">
          <el-row style="color: red" v-if="feeCategoryOperation == true">
            <div>{{ chargeCategoryManagement.tip1 }}</div>
            <!-- <div>{{ chargeCategoryManagement.tip3 }}</div> -->
          </el-row>
          <el-row style="color: red" v-else>
            <div>{{ chargeCategoryManagement.tip2 }}</div>
            <!-- <div>{{ chargeCategoryManagement.tip3 }}</div> -->
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button
          :size="size"
          @click.native="dialogVisibleFeeCategoryForm = false"
          >取消</el-button
        >
        <el-button
          :size="size"
          type="primary"
          @click.native="submitFeeCategoryForm"
          :loading="feeCategoryFormLoading"
          >确定</el-button
        >
        <el-button
          v-if="feeCategoryOperation == false"
          :size="size"
          type="danger"
          @click.native="deleteFeeCategoryForm"
          :loading="deleteFeeCategoryFormLoading"
          >删除类别</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加 和 修改 费用项目的dialog模态框-->
    <el-dialog
      :title="
        feeItemOperation
          ? chargeCategoryManagement.addFeeitem
          : chargeCategoryManagement.editFeeitem
      "
      width="45%"
      :visible.sync="dialogVisibleFeeItemForm"
      :close-on-click-modal="false"
      @close="closeChargeCategoryManagement"
    >
      <el-form
        :model="feeItemForm"
        label-width="100px"
        :rules="feeItemFormRules"
        ref="feeItemForm"
        label-position="right"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="chargeCategoryManagement.type"
              prop="expenseTypeId"
            >
              <el-select
                v-model="feeItemForm.expenseTypeId"
                class="width80"
                @change="handleSelectType"
                :disabled="!feeItemOperation"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="feeItemForm.isFixedPrice !== 0"
              :label="chargeCategoryManagement.chargeStandard"
              prop="chargeStandard"
            >
              <el-input
                v-model.trim="feeItemForm.chargeStandard"
                auto-complete="off"
                class="width80"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="chargeCategoryManagement.project"
              prop="itemName"
            >
              <el-input
                v-model.trim="feeItemForm.itemName"
                auto-complete="off"
                class="width80"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="chargeCategoryManagement.chargeStyle"
              prop="costType"
            >
              <el-select
                v-model="feeItemForm.costType"
                @change="handleSelectCostType"
                class="width80"
                :disabled="!feeItemOperation"
              >
                <el-option
                  v-for="item in costTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="code == 1">
          <el-col :span="8">
            <el-form-item
              :label="chargeCategoryManagement.roomType"
              prop="roomType"
            >
              <el-select
                v-model="feeItemForm.roomType"
                @change="handleSelectRoomType"
                class="width100"
                :disabled="!feeItemOperation"
              >
                <el-option
                  v-for="item in roomTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              :label="chargeCategoryManagement.orientation"
              prop="roomDirection"
            >
              <el-select
                v-model="feeItemForm.roomDirection"
                @change="handleSelectOrientation"
                class="width100"
                :disabled="!feeItemOperation"
              >
                <el-option
                  v-for="item in orientationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              :label="chargeCategoryManagement.isHaveToilet"
              prop="hasToilet"
            >
              <el-select
                v-model="feeItemForm.hasToilet"
                @change="handleSelectIsHaveToilet"
                class="width100"
                :disabled="!feeItemOperation"
              >
                <el-option
                  v-for="item in isHaveToiletOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="chargeCategoryManagement.moneyType"
              prop="isFixedPrice"
            >
              <el-select
                v-model="feeItemForm.isFixedPrice"
                class="width80"
                @change="handleSelectIsFixedPrice"
                :disabled="!feeItemOperation || isFixedPriceFlag"
              >
                <el-option
                  v-for="item in moneyTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="code == 2"
              :label="chargeCategoryManagement.careLevel"
              prop="careType"
            >
              <el-select
                v-model="feeItemForm.careType"
                class="width80"
                @change="handleSelectCareType"
                :disabled="!feeItemOperation"
              >
                <el-option
                  v-for="item in careTypeOptions"
                  :key="item.id"
                  :label="item.nursingCare"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          :label="chargeCategoryManagement.serviceContent"
          prop="content"
        >
          <el-input
            v-model.trim="feeItemForm.content"
            type="textarea"
            :rows="4"
            auto-complete="off"
            style="width: 92%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button
          :size="size"
          @click.native="dialogVisibleFeeItemForm = false"
          >取消</el-button
        >
        <el-button
          :size="size"
          type="primary"
          @click.native="submitFeeItemForm"
          :loading="feeItemFormLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { validateFee } from "@/utils/validator.js";
export default {
  name: "ChargeCategoryManagement",
  components: {},
  data() {
    return {
      careExpenseList: [], //护理费等级列表
      isFixedPriceFlag: false, //金额类型是否不可选
      tableLoading: false, //表格的loading
      editChargeCategoryDisabled: false, //管理费用类别按钮默认不可以点击  当有费用类别时才可以点击
      size: "medium", //按钮的尺寸
      chargeCategoryManagement: {
        newFeeCategory: "新建费用类别",
        managementFeeCategory: "管理费用类别",
        addFeeItem: "添加费用项目",
        category: "类别",
        project: "项目",
        chargingStandard: "收费标准",
        serviceContent: "服务内容",
        operation: "操作",
        serviceCategory: "服务类别:",
        fixChargeCategoryName: "服务类别名称",
        categoryRemark: "类别说明:",
        categoryA: "本类别中项目是否可以多选:",
        categoryB: "本类别中是否必选一个项目:",
        categoryC: "本类别中是否默认选择第一个项目:",
        tip1: "*提示:床位费,护理费和押金是固定项目,无需再添加",
        tip2: "*提示:床位费,护理费和押金是固定类别,不能删除和修改类别名称",
        tip3: "*提示:周期缴费项目为不固定的金额类别中是否默认选中第一项必须为是（如：电费、水费）",
        yes: "是",
        no: "否",
        addFeeitem: "添加费用项目",
        editFeeitem: "修改费用项目",
        type: "类型",
        chargeStandard: "收费标准",
        project: "项目",
        chargeStyle: "收费方式",
        moneyType: "金额类型",
        careLevel: "护理等级",
        serviceContent: "服务内容",
        roomType: "房间类型",
        orientation: "朝向",
        isHaveToilet: "是否带厕所",
        notEmpty: "不能为空",
        onlyNumber: "请输入阿拉伯数字",
        loadingText: "拼命加载中......",
        maxText: "最多不能超过20个字符"
      }, //引入 lang 里面的字符串资源,
      spanArr: [], //spanArr是一个空的数组，用于存放每一行记录的合并数；
      pos: 0, //pos是spanArr的索引
      //表格数据源模拟数据
      tableData: [],
      //新增费用类别的dialog配置
      dialogVisibleFeeCategoryForm: false, //dialog默认是关闭
      feeCategoryFormLoading: false, //确定按钮的loading加载  默认为false
      deleteFeeCategoryFormLoading: false, //删除按钮的loading加载 默认为false
      feeCategoryForm: {
        id: "",
        name: "",
        remark: "",
        code:"",
        canMultipleChoose: "",
        needSelectOne: "",
        isSelectFirstone: "",
        fixChargeCategoryName: "", //添加修改服务类别名称 by xiang
      }, //数据源
      feeCategoryFormRules: {
        name: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
        ],
        canMultipleChoose: [
          {
            required: true,
            message: "不能为空",
            trigger: "change",
          },
        ],
        needSelectOne: [
          {
            required: true,
            message: "不能为空",
            trigger: "change",
          },
        ],
        isSelectFirstone: [
          {
            required: true,
            message: "不能为空",
            trigger: "change",
          },
        ],
      }, //正则验证规则
      feeItemOptions: [], //修改费用类别下拉框的数据
      feeCategoryOperation: true, //新增费用类别和修改费用类别的dialog打开时的状态
      //添加费用项目的dialog模态框
      code: "", //区分 费用类别的  两个固定的 床位费为1 护理费为2 ； 其他的是新添加的 code都为0
      dialogVisibleFeeItemForm: false,
      feeItemFormLoading: false,
      feeItemOperation: true, //费用项的新增或者修改的dialog打开时的状态
      feeItemForm: {}, //数据源
      feeItemOptionsCode: "", //类别的code值
      isfeeCategory: true, //判断是否是固定类别
      feeItemFormRules: {
        expenseTypeId: [
          {
            required: true,
            message: "不能为空",
            trigger: "change",
          },
        ],
        chargeStandard: [
          { required: true, validator: validateFee, trigger: "blur" },
        ],
        itemName: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "最多不能超过20个字符",
          },
        ],
        costType: [
          {
            required: true,
            message: "不能为空",
            trigger: "change",
          },
        ],
        roomType: [
          {
            required: true,
            message: "不能为空",
            trigger: "change",
          },
        ],
        roomDirection: [
          {
            required: true,
            message: "不能为空",
            trigger: 'change',
          },
        ],
        hasToilet: [
          {
            required: true,
            message: "不能为空",
            trigger: "change",
          },
        ],
        isFixedPrice: [
          {
            required: true,
            message: "不能为空",
            trigger: "change",
          },
        ],
        careType: [
          {
            required: true,
            message: "不能为空",
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
          { min: 1, max: 300, message: "长度不能超过300个字符" }, //by xiang
        ],
      },
      //几个下拉框
      typeOptions: [], //类型
      roomTypeOptions: [], //房间类型
      orientationOptions: [], //朝向
      isHaveToiletOptions: [], //是否待测所
      moneyTypeOptions: [], //金额类型
      costTypeOptions: [], //收费方式
      careTypeOptions: [], //护理等级
    };
  },
  methods: {
    /* 
      新增费用类别
    */
    addChargeCategory() {
      this.$nextTick(() => {
        if (this.$refs.feeCategoryForm != undefined) {
          this.$refs["feeCategoryForm"].resetFields();
        }
      });
      this.feeCategoryOperation = true; //新增时 为true
      this.dialogVisibleFeeCategoryForm = true;
      this.feeCategoryForm = {
        //数据源
        name: "",
        remark: "",
        canMultipleChoose: "",
        needSelectOne: "",
        isSelectFirstone: "",
        fixChargeCategoryName: "",
      };
    },

    /* 
      修改费用类别
    */
    editChargeCategory() {
      this.$nextTick(() => {
        if (this.$refs.feeCategoryForm != undefined) {
          this.$refs["feeCategoryForm"].resetFields();
        }
      });
      this.feeCategoryOperation = false; //修改时为false
      this.dialogVisibleFeeCategoryForm = true;
      console.log(this.feeCategoryForm.id, this.feeCategoryForm.name);
      this.queryAll(); //重新获取数据
    },

    /* 
      服务种类的下拉框的change事件
    */
    handleSelectServiceCategory(value) {
      console.log(value);
      var name = "";
      this.feeItemOptions.forEach((item) => {
        if (value == item.id) {
          name = item.name;
          this.feeItemOptionsCode = item.code;
        }
      });
      //固定类别名称不能修改 by xiang
      if (this.feeItemOptionsCode !== 0) {
        this.isfeeCategory = true;
      } else {
        this.isfeeCategory = false;
      }
      console.log(value, name);
      //this.feeCategoryForm.fixChargeCategoryName = name
      //by  guo 2019-11-16-17:57 修改  不能用=号赋值  视图不会改变  导致input框的数据无法被修改
      this.$set(this.feeCategoryForm, "fixChargeCategoryName", name);
      this.getFeeCategoryDetail(value, name);
    },

    //关闭弹窗时isfeeCategory为 true by xiang
    closeDialogVisibleFeeCategoryForm() {
      this.isfeeCategory = true;
    },
    //关闭修改费用弹窗
    closeChargeCategoryManagement() {
      this.$refs["feeItemForm"].resetFields();
    },
    /* 
      类型下拉框的change事件
    */
    handleSelectType(value) {
      this.$refs["feeItemForm"].clearValidate(); //切换的时候清空校验 by xiang
      console.log(value);
      this.typeOptions.forEach((item) => {
        console.log(item);
        if (value == item.id) {
          this.code = item.code;
          //by guo 2019-11-06-10:00 添加  当费用类型code=1床位费  code=2护理费 金额类型应该为固定的
          if (this.code == 1) {
            this.feeItemForm.isFixedPrice = 1;
            this.isFixedPriceFlag = true;
          } else {
            this.isFixedPriceFlag = false;
          }
        }
      });
      console.log(this.code);
    },

    /* 
      收费方式下拉框的change事件
    */
    handleSelectCostType(value) {
      console.log(value);
    },

    /* 
      房间类型下拉框的change事件
    */
    handleSelectRoomType(value) {
      console.log(value);
      console.log(this.feeItemForm);
      if (
        this.feeItemForm.itemName == "" ||
        this.feeItemForm.itemName == "单人间" ||
        this.feeItemForm.itemName == "双人间" ||
        this.feeItemForm.itemName == "三人间" ||
        this.feeItemForm.itemName == "四人及四人间以上"
      ) {
        console.log(this.roomTypeOptions[value - 1]);
        this.feeItemForm.itemName = this.roomTypeOptions[value - 1].label;
      }
      if (
        this.feeItemForm.content == "" ||
        this.feeItemForm.content == "单人间" ||
        this.feeItemForm.content == "双人间" ||
        this.feeItemForm.content == "三人间" ||
        this.feeItemForm.content == "四人及四人间以上"
      ) {
        console.log(this.roomTypeOptions[value - 1]);
        this.feeItemForm.content = this.roomTypeOptions[value - 1].label;
      }
    },
    /* 
      是否带厕所的change事件
    */
    handleSelectIsHaveToilet(value) {
      console.log(value);
      console.log(this.feeItemForm);
      if (
        this.feeItemForm.itemName == "" ||
        this.feeItemForm.itemName == "单人间" ||
        this.feeItemForm.itemName == "单人间带厕所" ||
        this.feeItemForm.itemName == "单人间不带厕所" ||
        this.feeItemForm.itemName == "双人间" ||
        this.feeItemForm.itemName == "双人间带厕所" ||
        this.feeItemForm.itemName == "双人间不带厕所" ||
        this.feeItemForm.itemName == "三人间" ||
        this.feeItemForm.itemName == "三人间带厕所" ||
        this.feeItemForm.itemName == "三人间不带厕所" ||
        this.feeItemForm.itemName == "四人及四人间以上" ||
        this.feeItemForm.itemName == "四人及四人间以上带厕所" ||
        this.feeItemForm.itemName == "四人及四人间以上不带厕所"
      ) {
        var haveToilet = value == 1 ? "带厕所" : "不带厕所";
        this.feeItemForm.itemName =
          this.roomTypeOptions[this.feeItemForm.roomType - 1].label +
          haveToilet;
      }
      if (
        this.feeItemForm.content == "" ||
        this.feeItemForm.content == "单人间" ||
        this.feeItemForm.content == "单人间带厕所" ||
        this.feeItemForm.content == "单人间不带厕所" ||
        this.feeItemForm.content == "双人间" ||
        this.feeItemForm.content == "双人间带厕所" ||
        this.feeItemForm.content == "双人间不带厕所" ||
        this.feeItemForm.content == "三人间" ||
        this.feeItemForm.content == "三人间带厕所" ||
        this.feeItemForm.content == "三人间不带厕所" ||
        this.feeItemForm.content == "四人及四人间以上" ||
        this.feeItemForm.content == "四人及四人间以上带厕所" ||
        this.feeItemForm.content == "四人及四人间以上不带厕所"
      ) {
        var haveToilet = value == 1 ? "带厕所" : "不带厕所";
        this.feeItemForm.content =
          this.roomTypeOptions[this.feeItemForm.roomType - 1].label +
          haveToilet;
      }
    },

    /* 
      朝向下拉框的change事件
    */
    handleSelectOrientation(value) {
      console.log(value);
    },

    /* 
      金额类型的change事件
    */
    handleSelectIsFixedPrice(value) {
      console.log(value);
      this.feeItemForm.isFixedPrice = value;
      //by guo 2019-10-15 20:57 添加 需要判断徐选取的为不固定---0 需要清除收费标准的值  防止先选取了固定  输入了收费标准之后在更换为不固定的  数据会残留
      if (value == 0) {
        this.feeItemForm.chargeStandard = "";
      }
      console.log(this.feeItemForm.isFixedPrice);
    },

    /* 
      护理等级的change事件
    */
    handleSelectCareType(value) {
      console.log(value);
    },

    /* 
      新增 和 修改费用类别提交数据
    */
    submitFeeCategoryForm() {
      this.$refs.feeCategoryForm.validate((valid) => {
        if (valid) {
          var url = "";
          let params = {};
          params = Object.assign({}, this.feeCategoryForm);
          console.log(params);
          /* this.feeCategoryOperation 为 true是新增  false为修改 */
          if (this.feeCategoryOperation == true) {
            url = "omc/expenseType/add";
          } else {
            url = "omc/expenseType/edit";
            params.name = this.feeCategoryForm.fixChargeCategoryName; //修改费用类别传入的名字更改为input框里的值  by xiang
          }
          console.log(url);
          this.feeCategoryFormLoading = true;
          this.$postJson(url, params).then((res) => {
            console.log(params);
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
              this.$refs["feeCategoryForm"].resetFields();
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.queryAll();
            this.queryFeeData();
            this.feeCategoryFormLoading = false;
            this.dialogVisibleFeeCategoryForm = false;
          });
        }
      });
    },
    /*
      修改费用类别 by xiang  
     */
    fixFeeCategoryForm() {
      this.feeCategoryOperation = true;
    },

    /* 
      删除费用类别 提交数据
    */
    deleteFeeCategoryForm() {
      this.$confirm("确定要删除该类别吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false,
      })
        .then(() => {
          let expenseTypeId = this.feeCategoryForm.id;
          this.$postJson(
            "omc/expenseType/deleteById/" +
              expenseTypeId
          ).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.queryAll();
            this.queryFeeData();
            this.editChargeCategoryDisabled = false;
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    /* 
      添加费用项目
    */
    addCharge() {
      this.$nextTick(() => {
        if (this.$refs.feeItemForm != undefined) {
          this.$refs["feeItemForm"].resetFields();
        }
      });
      this.feeItemForm = {
        expenseTypeId: "",
        itemName: "",
        chargeStandard: "",
        content: "",
        costType: "",
        isFixedPrice: "",
        roomDirection: "",
        hasToilet: "",
        roomType: "",
        careType: "",
      };
      this.feeItemOperation = true; //打开的是添加项目的dialog
      this.dialogVisibleFeeItemForm = true;
      this.queryAll();
    },

    /* 
      添加 和 修改 费用项目提交数据
    */
    submitFeeItemForm() {
      this.$refs.feeItemForm.validate((valid) => {
        if (valid) {
          var url = "";
          let params = {};
          params = Object.assign({}, this.feeItemForm);
          //code==1 床位费  code==2 护理费   code==0 新添加的其他的类别都为0
          if (this.code == 1) {
            //去掉 护理的
            delete params.careType;
          } else if (this.code == 2) {
            //去掉床位费的
            delete params.roomType;
            delete params.roomDirection;
            delete params.hasToilet;
            if (this.feeItemOperation == true) {
              params.levelCareId = "" + params.careType;
            }
            delete params.careType;
          } else {
            //去掉 护理的和床位的
            delete params.careType;
            delete params.roomType;
            delete params.roomDirection;
            delete params.hasToilet;
          }
          if (this.feeItemForm.isFixedPrice == 0) {
            //金额为不固定时就传0
            params.chargeStandard = 0;
          }
          console.log(params);
          if (this.feeItemOperation == true) {
            url = "omc/expenseItem/add";
          } else {
            url = "omc/expenseItem/edit";
          }
          this.feeItemFormLoading = true;
          this.$postJson(url, params).then((res) => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
              this.$refs["feeItemForm"].resetFields();
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.feeItemFormLoading = false;
            this.dialogVisibleFeeItemForm = false;
            this.queryFeeData(); //刷新表格数据
            this.queryAll();
          });
        }
      });
    },

    /* 
      获取费用类别---查询类别以及消费项  用于类别下拉框
    */
    queryAll() {
      this.feeItemOptions = []; //清空数据，防止累加
      this.typeOptions = []; //清空数据，防止累加
      this.$postJson("omc/expenseType/queryAll").then(
        (res) => {
          if (res.code == 200) {
            if (res.result.length > 0) {
              res.result.forEach((item, index) => {
                if (index == 0) {
                  this.feeCategoryForm.id = item.id * 1;
                  this.feeCategoryForm.name = item.name;
                  this.feeCategoryForm.canMultipleChoose =
                    item.canMultipleChoose;
                  this.feeCategoryForm.needSelectOne = item.needSelectOne;
                  this.feeCategoryForm.isSelectFirstone = item.isSelectFirstone;
                  this.feeCategoryForm.remark = item.remark;
                }
                this.feeItemOptions.push({
                  id: item.id * 1,
                  name: item.name,
                  code: item.code,
                });
                this.typeOptions.push({
                  id: item.id * 1,
                  name: item.name,
                  code: item.code,
                });
              });
              this.feeItemOptionsCode = this.feeItemOptions[0].code;
              //this.feeCategoryForm.fixChargeCategoryName = this.feeItemOptions[0].name
              //by  guo 2019-11-16-17:57 修改  不能用=号赋值  视图不会改变  导致input框的数据无法被修改
              this.$set(
                this.feeCategoryForm,
                "fixChargeCategoryName",
                this.feeItemOptions[0].name
              );
              this.getFeeCategoryDetail(
                this.feeCategoryForm.id,
                this.feeCategoryForm.name
              );
              this.editChargeCategoryDisabled = false;
            } else {
              this.editChargeCategoryDisabled = true;
            }
          }
        }
      );
    },

    /* 
      用于表格的数据
    */
    queryFeeData() {
      this.careExpenseList = [];
      this.tableData = []; //查询前先清空数据
      this.tableLoading = true; //获取数据时tableLoading加载
      this.$postJson("omc/expenseType/queryAll").then(
        (res) => {
          console.log(res, "查询类别以及消费项22222222-------------");
          if (res.code == 200) {
            if (res.result.length > 0) {
              res.result.forEach((item, index) => {
                console.log(item);
                //判断小项是否存在  存在就展示所有的字段内容
                if (item.expenseItemList != null) {
                  item.expenseItemList.forEach((temp) => {
                    let feeDataObj = {};
                    feeDataObj.name = item.name;
                    feeDataObj.canMultipleChoose = item.canMultipleChoose;
                    feeDataObj.needSelectOne = item.needSelectOne;
                    feeDataObj.isSelectFirstone = item.isSelectFirstone;
                    feeDataObj.remark = item.remark;
                    feeDataObj.code = item.code;
                    feeDataObj.id = temp.id;
                    feeDataObj.expenseTypeId = temp.expenseTypeId;
                    feeDataObj.itemName = temp.itemName;
                    feeDataObj.chargeStandard = temp.chargeStandard;
                    feeDataObj.content = temp.content;
                    feeDataObj.costType = temp.costType;
                    feeDataObj.isFixedPrice = temp.isFixedPrice;
                    feeDataObj.roomDirection = temp.roomDirection;
                    feeDataObj.roomType = temp.roomType;
                    feeDataObj.hasToilet = temp.hasToilet;
                    feeDataObj.careType = temp.careType;
                    this.tableData.push(feeDataObj);
                    this.careExpenseList.push(
                      temp.levelCareName == ""
                        ? "未选择护理等级"
                        : temp.levelCareName
                    );
                  });
                } else {
                  //小项不存在 就只展示费用类别
                  let feeDataObj = {};
                  feeDataObj.name = item.name;
                  feeDataObj.canMultipleChoose = item.canMultipleChoose;
                  feeDataObj.needSelectOne = item.needSelectOne;
                  feeDataObj.isSelectFirstone = item.isSelectFirstone;
                  feeDataObj.remark = item.remark;
                  feeDataObj.code = item.code;
                  feeDataObj.id = "";
                  feeDataObj.expenseTypeId = "";
                  feeDataObj.itemName = "";
                  feeDataObj.chargeStandard = "";
                  feeDataObj.content = "";
                  feeDataObj.costType = "";
                  feeDataObj.isFixedPrice = "";
                  feeDataObj.roomDirection = "";
                  feeDataObj.roomType = "";
                  feeDataObj.hasToilet = "";
                  feeDataObj.careType = "";
                  this.tableData.push(feeDataObj);
                  this.careExpenseList.push("未选择护理等级");
                }
              });
            }
          }
          console.log(this.tableData, "this.tableData---------------------");
          this.getSpanArr(this.tableData);
          this.tableLoading = false;
        }
      );
    },

    /* 
      费用类别详情
    */
    getFeeCategoryDetail(id, name) {
      let params = {};
      params.id = id;
      params.name = name;
      this.$postJson(
        "omc/expenseType/get",
        params
      ).then((res) => {
        if (res.code == 200) {
          if (res.result != null) {
            this.feeCategoryForm.id = res.result.id * 1;
            this.feeCategoryForm.name = res.result.name;
            this.feeCategoryForm.code = ''+res.result.code;
            this.feeCategoryForm.canMultipleChoose =
              res.result.canMultipleChoose;
            this.feeCategoryForm.needSelectOne = res.result.needSelectOne;
            this.feeCategoryForm.isSelectFirstone = res.result.isSelectFirstone;
            this.feeCategoryForm.remark = res.result.remark;
            console.log(this.feeCategoryForm);
          }
        }
      });
    },

    /* 
      编辑表格行数据
    */
    handleEditFeeItem(index, row) {
      if (row.name == "护理费") {
        row.careType = this.careExpenseList[index];
      }
      this.$nextTick(() => {
        if (this.$refs.feeItemForm != undefined) {
          this.$refs["feeItemForm"].resetFields();
        }
      });
      this.feeItemOperation = false; //打开的是修改项目的dialog
      this.dialogVisibleFeeItemForm = true;
      this.feeItemForm = Object.assign({}, row);
      console.log(this.feeItemForm);
      this.code = this.feeItemForm.code;
      this.feeItemForm.careType = String(row.careType);
    },

    /* 
      删除表格行数据
    */
    handleDeleteFeeItem(index, row) {
      console.log(index, row);
      this.$confirm("确定要删除该费用项目吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false,
      })
        .then(() => {
          let expenseTypeId = row.id;
          this.$postJson(
            "omc/expenseItem/deleteById/" + expenseTypeId
          ).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.queryFeeData();
            this.queryAll();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    /* 
      处理表格的数据 用于合并表格
    */
    getSpanArr(data) {
      this.spanArr = [];
      this.pos = 0;
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同  通过表格中的 先判断expenseTypeId不为空  expenseTypeId字段来判断 它们是否是一类
          if (
            data[i].expenseTypeId != "" &&
            data[i].expenseTypeId === data[i - 1].expenseTypeId
          ) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
      console.log(this.spanArr, "this.spanArr");
    },

    /* 
      表格 类别的合并
    */
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        //console.log(_row,_col);
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },

    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },

    /* 
      初始化 房间类型
    */
    initialroomTypeOptions() {
      var roomType = ["单人间", "双人间", "三人间", "四人及四人间以上"];
      for (var i = 0; i < roomType.length; i++) {
        var item = {};
        item.value = i + 1;
        item.label = roomType[i];
        this.roomTypeOptions.push(item);
      }
    },

    /* 
      初始化 朝向
    */
    initialOrientationOptions() {
      var orientation = ["东", "南", "西", "北"];
      for (var i = 0; i < orientation.length; i++) {
        var item = {};
        item.value = i;
        item.label = orientation[i];
        this.orientationOptions.push(item);
      }
    },

    /* 
      初始化 是否带厕所
    */
    initialIsHaveToiletOptions() {
      var isHaveToilet = ["否", "是"];
      for (var i = 0; i < isHaveToilet.length; i++) {
        var item = {};
        item.value = i;
        item.label = isHaveToilet[i];
        this.isHaveToiletOptions.push(item);
      }
    },

    /* 
      初始化 金额类型
    */
    initialMoneyTypeOptions() {
      var moneyType = ["不固定", "固定"];
      for (var i = 0; i < moneyType.length; i++) {
        var item = {};
        item.value = i;
        item.label = moneyType[i];
        this.moneyTypeOptions.push(item);
      }
    },

    /* 
      初始化 收费方式
    */
    initialCostTypeOptions() {
      var costType = ["元/次", "元/天", "元/月", "元/年", "元/一次性"];
      for (var i = 0; i < costType.length; i++) {
        var item = {};
        item.value = i + 1;
        item.label = costType[i];
        this.costTypeOptions.push(item);
      }
    },

    /* 
      初始化  护理等级 
    */
    initialCareTypeOptions() {
      let params = {
        pageNum: 1,
        pageSize: 999,
        groupId: Number(sessionStorage.getItem("groupId")),
      };
      this.$postJson("omc/levelCare/select", params).then((res) => {
        if (res.code == 200) {
          console.log(res, "999999");
          this.careTypeOptions = res.result.list;
        } else {
          this.careTypeOptions = [];
        }
      });
      //自理--0  半自理--1或者2 这里就默认为1     失能--3
    },
  },
  created() {
    this.initialroomTypeOptions();
    this.initialOrientationOptions();
    this.initialIsHaveToiletOptions();
    this.initialMoneyTypeOptions();
    this.initialCostTypeOptions();
    this.initialCareTypeOptions();
  },
  mounted() {
    this.queryAll();
    this.queryFeeData();
  },
};
</script>
<style lang="scss" scoped>
.chargeCategoryManagement {
  width: 100%;
  padding-bottom: 30px;
  background: #fefefe;
  .imgMarginLeft {
    margin-left: 10px;
    cursor: pointer;
  }
  .radiomargiTtop {
    margin-top: 13px;
  }
  .width100 {
    width: 100% !important;
  }
}
.width80 {
  width: 80%;
}
::v-deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
</style>